import {HttpService} from "../../../services/http/Http.service";
import {Button, message, Modal, Space} from "antd";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import {SuspendRequest, SUSPENSION_REASON_LABELS} from "../../../model/models";
import React, {useState} from "react";

interface PaymentConfirmedProps {
    onClose: () => void,
    simulatorId?: number | undefined,
    personId?: number | undefined,
    onStatusChange?: (() => void),
    fetchAuditTrail: () => Promise<void>
}

export default function SuspendModal({
                                             onClose,
                                             simulatorId,
                                             personId,
                                             onStatusChange,
                                             fetchAuditTrail
                                         }: PaymentConfirmedProps) {

    const [loadingReason, setLoadingReason] = useState<string | null>(null);

    const suspendPractice = async (reason: keyof typeof SUSPENSION_REASON_LABELS) => {
        if (!personId || !simulatorId) return;

        const reasonKey = Object.keys(SUSPENSION_REASON_LABELS)
            .find(key => SUSPENSION_REASON_LABELS[key] === reason);

        if (!reasonKey) {
            console.error("Invalid reason value:", reason);
            message.error("Errore: motivo di sospensione non valido");
            return;
        }

        const requestBody: SuspendRequest = {
            reason: reasonKey
        }
        setLoadingReason(reasonKey);
        try {
            await HttpService.getInstanceAxios().post(`/file-ts/${simulatorId}/suspend/${personId}`, requestBody);
            message.success("Pratica sospesa con successo");

            onStatusChange?.();
            onClose()
            await fetchAuditTrail()
        } catch (error) {
            HttpErrorService.handle("Errore durante la sospensione della pratica", error, true);
        } finally {
            setLoadingReason(null);
        }
    };

    return (
        <>
            <Modal
                title={"Sospendi pratica"}
                open={true}
                footer={false}
                onClose={onClose}
                onCancel={onClose}
                width="fit-content"
            >
                <p>Per quale motivo vuoi sospendere la pratica?</p>
                <Space style={{display: "flex", justifyContent: "flex-end"}}>
                    <Button danger onClick={onClose}>
                        Annulla
                    </Button>
                    <Button
                        onClick={() => suspendPractice(SUSPENSION_REASON_LABELS.ISTRUTTORIA)}
                        type="primary"
                        loading={loadingReason === "ISTRUTTORIA"}
                        disabled={loadingReason !== null}
                    >
                        Istruttoria
                    </Button>
                    <Button
                        onClick={() => suspendPractice(SUSPENSION_REASON_LABELS.DECESSO)}
                        type="primary"
                        loading={loadingReason === "DECESSO"}
                        disabled={loadingReason !== null}
                    >
                        Decesso
                    </Button>
                </Space>
            </Modal>
        </>
    )
}